import React, { Component } from 'react';
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import Loader from "../loader/Loader";
import PlaceSlider from "../slider/slider";
import ImagesLoaded from "react-images-loaded";
import { cities } from "../../data/cities";
import { Link } from "react-router-dom";
import { sendEvent } from "../../helpers/analytics";

class PlaceView extends Component {

  state = {
    moveX: 0,
    moveY: 0,
    loaded: false
  }

  componentDidMount () {
    sendEvent('window', 'show', `preview - ${this.props.city.title}`)
  }

  isPortrait = () => {
    return window.innerHeight > window.innerWidth
  }

  moveClouds = (e) => {
    const pageX = e.clientX, pageY = e.clientY;
    this.setState({moveX: pageX/100, moveY: pageY/100})
  }

  handleDone = instance => {
    this.setState({loaded: true})
    console.log('loaded', this.state.loaded)
  };

  render () {
    const { city } = this.props

    const { moveX, moveY, loaded } = this.state
    return (
      <div  onMouseMove={this.moveClouds}>
        <ReactCSSTransitionGroup
          transitionName="loader"
          transitionEnterTimeout={10}
          transitionLeaveTimeout={500}
        >
          {!loaded ? <Loader  /> : null}
        </ReactCSSTransitionGroup>

        <ImagesLoaded
          done={this.handleDone}
        >
          <div style={{position: 'absolute', width: 1, height: 1, top: -100, left: -100, zIndex: 0, overflow: 'hidden'}}>
            <img src="/images/wing.png" alt=""/>
            {this.isPortrait() ?
              <img src="/images/place_bg_mobile.png" alt=""/>
              :
              <img src="/images/place_bg.png" alt=""/>
            }
            {cities.map(city => {
              return <img key={city.title} src={`${city.image}`} alt=""/>
            })}
          </div>
        </ImagesLoaded>


        <PlaceSlider id={city.id} move={[moveX, moveY]}  />


        <div className="wing__wrapper" style={{transform: `translate(${-1*moveX}px, ${-1*moveY}px)`}} >
          <div className="wing" />
        </div>
        <div className="clouds" style={{transform: `translate(${-1*moveX}px, ${moveY}px)`}} />
        <div className="place__overlay" />
        <div className="windows" />
        <div className="place__block">
          <div className="container flex-center-vertical">
            <div className="place__info">
              <ReactCSSTransitionGroup
                transitionName="place_title"
                transitionAppearTimeout={1400}
                transitionAppear={true}
                transitionEnter={false}
                transitionLeave={false}
              >
                <h1 className="place__title">{city.title}</h1>
              </ReactCSSTransitionGroup>
            </div>
            <div className="place__buttons">
              <span onClick={() => sendEvent('window', 'show', `go to article`)}>
              <Link to={`/article/${city.id}`} className="place__link">
                <img src="/images/plane.png" alt=""/>
              </Link>
              </span>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PlaceView


// WEBPACK FOOTER //
// ./src/components/place/place.js